// solution Routes
import {
  // routeParams,
  moduleDetailsPath,
  // buildAppRoutePath,
  buildModuleDetailsRouteName,
  buildModuleRouteName,
  buildModuleRoutePath,
  buildModuleChildRouteName
} from "@/router/solution/solutionRoutes";

// services
import { applicationName as application } from "@/services/solution/solutionService";
import {
  routeName as cityCenterRoute,
  modulePageTitle as cityCenterPageTitle
} from "@/services/cityCenter/cityCenterService";

// router
import { buildAppRouteName } from "@/router/solution/solutionRoutes";
import { pascalToHyphen } from "@/utils";

/**
 * Get City Center Module Route Name
 * @param {String|string} moduleRouteName
 * @returns {String|string}
 */
const moduleRouteName = moduleRouteName =>
  buildModuleRouteName(application.CityCenter, moduleRouteName);
/**
 * Get City Center Module Details Route Name
 * @param {String|string} moduleRouteName
 * @returns {string}
 */
const moduleDetailsRouteName = moduleRouteName => {
  return buildModuleDetailsRouteName(application.CityCenter, moduleRouteName);
};
/**
 * Get City Center Module Details Route Name
 * @param {String|string} moduleRouteName
 * @param {String|string} moduleChildName
 * @returns {string}
 */
const moduleChildRouteName = (moduleRouteName, moduleChildName) => {
  return buildModuleChildRouteName(
    application.CityCenter,
    moduleRouteName,
    moduleChildName
  );
};

const cityCenterRoutes = [
  {
    path: "",
    name: buildAppRouteName(application.CityCenter),
    component: () => import("@/views/cityCenter/home/CityCenterHome"),
    meta: { requiresAuth: true },
    children: [
      {
        path: buildModuleRoutePath(cityCenterRoute.Dashboard),
        name: moduleRouteName(cityCenterRoute.Dashboard),
        meta: { requiresAuth: true, title: cityCenterPageTitle.Dashboard },
        props: true,
        component: () => import("@/views/cityCenter/dashboard/DashboardContent")
      },
      // {
      //   path: buildModuleRoutePath(cityCenterRoute.Time),
      //   name: moduleRouteName(cityCenterRoute.Time),
      //   meta: { requiresAuth: true },
      //   props: true,
      //   component: () => import("@/views/cityCenter/myTime/MyTimeContent"),
      //   children: [
      //     {
      //       path: moduleDetailsPath,
      //       name: moduleDetailsRouteName(cityCenterRoute.Time),
      //       meta: { requiresAuth: true },
      //       props: true,
      //       component: () =>
      //         import("@/views/cityCenter/myTime/MyTimeDetails")
      //     }
      //   ]
      // },
      {
        path: buildModuleRoutePath(cityCenterRoute.UserManagement),
        name: moduleRouteName(cityCenterRoute.UserManagement),
        meta: { requiresAuth: true, title: cityCenterPageTitle.UserManagement },
        props: true,
        component: () =>
          import("@/views/cityCenter/userManagement/UserManagementContent"),
        children: [
          {
            // path: pascalToHyphen("RoleGroups").concat("/").concat(moduleDetailsPath),
            path: `${pascalToHyphen("RoleGroups")}/${moduleDetailsPath}`,
            name: moduleDetailsRouteName(cityCenterRoute.UserManagement),
            meta: {
              requiresAuth: true,
              title: cityCenterPageTitle.RoleGroupAssociation
            },
            props: true,
            component: () =>
              import("@/views/cityCenter/userManagement/RoleGroupsAssociation")
          },
          {
            path: `${pascalToHyphen("Association")}/${moduleDetailsPath}`,
            name: moduleChildRouteName(
              cityCenterRoute.UserManagement,
              "Association"
            ),
            meta: {
              requiresAuth: true,
              title: cityCenterPageTitle.UserAssociation
            },
            props: true,
            component: () =>
              import("@/views/cityCenter/userManagement/UserAssociationContent")
          }
        ]
      },
      {
        path: buildModuleRoutePath(cityCenterRoute.RoleGroup),
        name: moduleRouteName(cityCenterRoute.RoleGroup),
        meta: { requiresAuth: true, title: cityCenterPageTitle.RoleGroup },
        props: true,
        component: () => import("@/views/cityCenter/roleGroup/RoleGroupContent")
        // children: [
        //   {
        //     path: moduleDetailsPath,
        //     name: moduleDetailsRouteName(cityCenterRoute.RoleGroup),
        //     meta: { requiresAuth: true, title: "Role Association" },
        //     props: true,
        //     component: () =>
        //       import("@/views/cityCenter/roleGroup/RoleAssociation")
        //   }
        // ]
      },
      // {
      //   path: buildModuleRoutePath(cityCenterRoute.RoleGroupAssociation),
      //   name: moduleRouteName(cityCenterRoute.RoleGroupAssociation),
      //   meta: { requiresAuth: true },
      //   props: true,
      //   component: () =>
      //     import(
      //       "@/views/cityCenter/roleGroupAssociation/RoleGroupAssociationContent"
      //     )
      // },
      {
        path: buildModuleRoutePath(cityCenterRoute.ProcessConfiguration),
        name: moduleRouteName(cityCenterRoute.ProcessConfiguration),
        meta: {
          requiresAuth: true,
          title: cityCenterPageTitle.ProcessConfiguration
        },
        props: true,
        component: () =>
          import(
            "@/views/cityCenter/workflowSetup/processConfiguration/ProcessConfigurationContent"
          )
      },
      {
        path: buildModuleRoutePath(cityCenterRoute.ProcessAssociation),
        name: moduleRouteName(cityCenterRoute.ProcessAssociation),
        meta: {
          requiresAuth: true,
          title: cityCenterPageTitle.ProcessAssociation
        },
        props: true,
        component: () =>
          import(
            "@/views/cityCenter/workflowSetup/processAssociation/ProcessAssociationContent"
          )
      },
      {
        path: buildModuleRoutePath(cityCenterRoute.StatusConfiguration),
        name: moduleRouteName(cityCenterRoute.StatusConfiguration),
        meta: {
          requiresAuth: true,
          title: cityCenterPageTitle.StatusConfiguration
        },
        props: true,
        component: () =>
          import(
            "@/views/cityCenter/workflowSetup/statusConfiguration/StatusConfigurationContent"
          )
      },
      {
        path: buildModuleRoutePath(cityCenterRoute.UserGroup),
        name: moduleRouteName(cityCenterRoute.UserGroup),
        meta: { requiresAuth: true, title: cityCenterPageTitle.UserGroup },
        props: true,
        component: () =>
          import("@/views/cityCenter/userGroup/UserGroupContent"),
        children: [
          {
            path: `${pascalToHyphen("Users")}/${moduleDetailsPath}`,
            name: moduleChildRouteName(
              cityCenterRoute.UserGroup,
              "UsersDetail"
            ),
            meta: {
              requiresAuth: true,
              title: cityCenterPageTitle.UserGroupUsers
            },
            props: true,
            component: () => import("@/views/cityCenter/userGroup/UsersDetail")
          },
          {
            path: `${pascalToHyphen("Associations")}/${moduleDetailsPath}`,
            name: moduleChildRouteName(
              cityCenterRoute.UserGroup,
              "Associations"
            ),
            meta: {
              requiresAuth: true,
              title: cityCenterPageTitle.UserGroupAssociations
            },
            props: true,
            component: () => import("@/views/cityCenter/userGroup/Associations")
          }
        ]
      },
      {
        path: buildModuleRoutePath(cityCenterRoute.ApprovalGroup),
        name: moduleRouteName(cityCenterRoute.ApprovalGroup),
        meta: { requiresAuth: true, title: cityCenterPageTitle.ApprovalGroup },
        props: true,
        component: () =>
          import("@/views/cityCenter/approvalGroup/ApprovalGroupContent"),
        children: [
          {
            path: `${pascalToHyphen("Users")}/${moduleDetailsPath}`,
            name: moduleChildRouteName(
              cityCenterRoute.ApprovalGroup,
              "ApprovalGroupUsers"
            ),
            meta: {
              requiresAuth: true,
              title: cityCenterPageTitle.ApprovalGroupUsers
            },
            props: true,
            component: () =>
              import(
                "@/views/cityCenter/approvalGroup/ApprovalGroupUsersDetail"
              )
          },
          {
            path: `${pascalToHyphen("Associations")}/${moduleDetailsPath}`,
            name: moduleChildRouteName(
              cityCenterRoute.ApprovalGroup,
              "ApprovalGroupAssociations"
            ),
            meta: {
              requiresAuth: true,
              title: cityCenterPageTitle.ApprovalGroupAssociations
            },
            props: true,
            component: () =>
              import(
                "@/views/cityCenter/approvalGroup/ApprovalGroupAssociations"
              )
          }
        ]
      }
      // {
      //   path: `:${routeParams.moduleName}`,
      //   name: moduleRouteName(cityCenterRoute.NotImplemented),
      //   meta: { requiresAuth: true },
      //   props: true,
      //   component: () =>
      //     import("@/views/cityCenter/mock/CityCenterContent"),
      //   children: [
      //     {
      //       path: moduleDetailsPath,
      //       name: moduleDetailsRouteName(cityCenterRoute.NotImplemented),
      //       meta: { requiresAuth: true },
      //       props: true,
      //       component: () =>
      //         import("@/views/cityCenter/mock/CityCenterDetails")
      //     }
      //   ]
      // }
    ]
  }
];

export { cityCenterRoutes, moduleRouteName, moduleChildRouteName };
